import styled from 'styled-components'
import { BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'
import { PRIMARY_DARK_COLOR, SELECTED_ITEM_BG_COLOR } from '@CSSVars/colors'

import AppButton from 'Components/AppButton'

export const _ListingCountFloatingBar = styled.div`

  display: flex;
  align-items: center;
  position: sticky;
  width: 100%;
  left: 0;
  bottom: 0;
  height: 64px;
  background: ${({ mobileStyle }) => (mobileStyle ? 'transparent' : 'white')};
  box-shadow: ${({ mobileStyle }) => (mobileStyle ?
    'none' : '0 -5px 8px 3px rgba(215,215,215,0.4)')};
  z-index: 100;
  padding: 0 16px;
  justify-content: flex-end;
  button {
    min-width: 190px;
  }
  span {
    color: white;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    position: fixed;
  }
  @media screen and (min-width: ${BREAK_POINT_MD}) {
    bottom: ${({ haveComparedListings }) => (haveComparedListings ? '20px' : 0)};
  }


  ${({ mobileStyle }) => (mobileStyle ? `
    padding: 16px;
    height: 76px;
    button {
      width: 100%;
      height: 44px;
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
      background-color: ${PRIMARY_DARK_COLOR} !important;
      border-radius: 10px;
    }
    ` : '')};

`

export const _ViewListingBtn = styled(AppButton)`
  :active {
    background: ${SELECTED_ITEM_BG_COLOR} !important;
  }
`


export const _LeftButton = styled(AppButton)`
  text-decoration: underline;
  margin-left: 12px;
  margin-right: 25px;
  min-width: initial !important;
  &:hover {
    cursor: pointer;
  }


`
